import React, { useState, useEffect } from 'react';
import { Tab, Tabs, Typography } from '@guildeducationinc/recess';
import { MemberTraits } from '@src/graphql/home/queries/memberTraits';
import { clickable } from '@src/analytics';
import { useMemberTraitsContext } from '@src/context/MemberTraitsContext';
import Explore from './Explore/Explore';
import Recommendations from './Recommendations/Recommendations';
import Bookmarks from './Bookmarks/Bookmarks';
import Applications from './Applications/Applications';
import Skeleton from '../Shared/Skeleton/Skeleton';
import './LearnSkills.scss';

const LearnSkills: React.FC = () => {
  const ANALYTICS_ID = 'learn_skills';
  const [activeTab, setActiveTab] = useState(0);
  const { memberTraits } = useMemberTraitsContext();

  const getDefaultTabName = (traits: MemberTraits | undefined): string => {
    let defaultTab = 'explore_tab';

    if (
      traits?.hasStartedApplications ||
      traits?.hasApprovedApplications ||
      traits?.hasCompletedApplications
    ) {
      defaultTab = 'applications_tab';
    } else if (traits?.hasCoachRecommendations) {
      defaultTab = 'coach_recommendations_tab';
    } else if (traits?.hasBookmarks) {
      defaultTab = 'bookmarks_tab';
    }

    return defaultTab;
  };

  const defaultTab = getDefaultTabName(memberTraits);

  const activeTabLookup = {
    explore_tab: 0,
    coach_recommendations_tab: 1,
    bookmarks_tab: 2,
    applications_tab: 3,
  };

  const stringLookup = ['explore', 'coach_recommendations', 'bookmarks', 'applications'];

  useEffect(() => {
    setActiveTab(activeTabLookup[defaultTab]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab]);

  return (
    <div className='learnSkills'>
      <div className='headingSection'>
        <Typography variant='h2'>Learn the skills you need.</Typography>
        <Typography>
          Guild&apos;s catalog is full of high-quality education programs for working adults like
          you.
        </Typography>
      </div>
      <Skeleton height='28rem' marginBottom='4rem'>
        <Tabs
          activeIndex={activeTab}
          onActive={(index) => {
            clickable({
              product: 'home',
              loggedIn: true,
              tag: ANALYTICS_ID,
              text: stringLookup[index],
              type: 'tab',
            });
            setActiveTab(index);
          }}
          className='tabGroup'
        >
          <Tab title='All programs'>
            <Explore analyticsId={ANALYTICS_ID} />
          </Tab>
          <Tab title='Recommendations'>
            <Recommendations />
          </Tab>
          <Tab title='Bookmarks'>
            <Bookmarks />
          </Tab>
          <Tab title='Applications'>
            <Applications />
          </Tab>
        </Tabs>
      </Skeleton>
    </div>
  );
};

export default LearnSkills;
